module.exports = __webpack_public_path__ + "static/Blutorange-e98696665fe5c74a8c89bb354f410d22.png";